import React from 'react';

import { Box } from '@betterment/samba-react';

export const AccountWithPurposeIcon: React.FC<{ accountIconUrl: string; purposeIconUrl?: string }> = ({
  accountIconUrl,
  purposeIconUrl,
}) => (
  <Box css={{ position: 'relative', width: 'size.450', height: 'size.450', flexShrink: 0 }}>
    {purposeIconUrl && (
      <Box
        css={{
          width: 'size.250',
          height: 'size.250',
          padding: '0',
          borderRadius: 'medium',
          borderColor: 'border.onPrimary',
          border: '2px solid',
          position: 'absolute',
          top: '-12px',
          left: '-2px',
          overflow: 'hidden',
        }}
      >
        <img src={purposeIconUrl} alt="PurposeIcon" style={{ position: 'absolute' }} />
      </Box>
    )}
    <img src={accountIconUrl} alt="Icon" />
  </Box>
);
